import React, {PropTypes, Component} from 'react';
import { connect } from 'react-redux';
import EmailList from './EmailList';
import Button from '../../../../../common/components/Button';
import Search from '../../../../../common/components/Search';
import CreateEmailTemplate from '../Create';
import EditEmailTemplate from '../Edit';
import { getEmailTemplates } from '../../../../../redux/actionCreators/async/emails';

import {chain, intersectionWith, map, clone, find} from 'lodash';

@connect(undefined, {
  getEmailTemplates
})
export default class SettingsEmailTab extends Component {

  static propTypes = {
    getEmailTemplates: PropTypes.func.isRequired,
  }

  constructor() {
    super();

    this.state = {
      terms: [],
      createEmail: false,
      editEmail: false,
      templates: [],
      selectedTemplate: undefined
    };

    this.onUpdate = :: this.onUpdate;
  }

  componentDidMount() {

    this.props.getEmailTemplates(true)
      .then(templates => this.setState({templates}));

  }

  onTermChange(terms = []) {
    this.setState({terms});
  }

  onClose = () => {
    this.setState({createEmail: false, editEmail: false});
  }

  showCreateEmailModal() {
    this.setState({createEmail: true});
  }

  showEditEmailModal() {
    this.setState({editEmail: true});
  }

  onSelectTemplate(selectedTemplate) {

    let templates = clone(this.state.templates);

    templates =  map(templates, template => {
      if(template.id === selectedTemplate.id) {
          selectedTemplate.selected = true;
          return selectedTemplate;
      }
      template.selected = false;
      return template;
    });

    this.setState({templates, selectedTemplate});
  }

  onUpdate(templates) {

    if(! this.state.selectedTemplate) {
      this.setState({ templates });
      return;
    }

    const selectedTemplate = find(templates, {id: this.state.selectedTemplate.id});

    if(selectedTemplate) {

        templates =  map(templates, template => {
        if(template.id === selectedTemplate.id) {
            selectedTemplate.selected = true;
            return selectedTemplate;
        }
        template.selected = false;
        return template;
      });

    }


    this.setState({ templates, selectedTemplate });

  }

  render() {

    const matchCriteria = (template) => {

        const isLowerCaseOrIgnore = term => typeof term === 'string' ? term.toLowerCase() : term;

        const terms = chain(template)
          .values()
          .map(isLowerCaseOrIgnore)
          .value();

        const searchTerms = this.state.terms.map(isLowerCaseOrIgnore);

        const comparator = (value, otherValue) => typeof value === 'string' && value.search(otherValue) !== -1;

        if(this.state.terms.length) {
          return intersectionWith(terms, searchTerms, comparator).length;
        }

        return true;

    };

    const matchedTemplates = chain(this.state.templates)
      .filter(matchCriteria)
      .value();

    return (
    <div className='settings-emails-tab'>
      {this.state.createEmail && <CreateEmailTemplate onClose={this.onClose} onUpdate={this.onUpdate}  />}
      {this.state.editEmail && <EditEmailTemplate onClose={this.onClose} onUpdate={this.onUpdate} template={this.state.selectedTemplate} />}

      <Search
        onTermChange={::this.onTermChange}
        baseUrl='/admin/settings/emails'
      />
       <h1></h1>
      <div className='emails-container'>
         <div className='email-list-container'>
            <h1 className='title'>Email Templates</h1>
            <EmailList templates={matchedTemplates} onSelectTemplate={::this.onSelectTemplate} />
        </div>
        <div className='email-preview'>

          <div className='buttons-container'>
            <div className='action-button'>
              <Button
                  data-id='edit-email-template'
                  className='button-secondary button-secondary-create-edit-template'
                  label='CREATE TEMPLATE'
                  onClick={::this.showCreateEmailModal}
              />
            </div>
            <div className='action-button'>
              <Button
                  disabled={!this.state.selectedTemplate}
                  data-id='create-email-template'
                  className='button-secondary button-secondary-create-edit-template'
                  label='EDIT TEMPLATE'
                  onClick={::this.showEditEmailModal}
              />
            </div>
        </div>

          {
            !this.state.selectedTemplate &&
            <div>
              <h2>No Emails Selected</h2>
              <p>Please select an email template from the list to the left to view it.</p>
            </div>
          }

          {
            this.state.selectedTemplate &&
            <div>
              <h2>{this.state.selectedTemplate.name}</h2>
              <br />
              <div dangerouslySetInnerHTML={{__html: this.state.selectedTemplate.html}} />
            </div>
          }

        </div>
      </div>

    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Settings/Emails/Landing/index.js